import { useState, useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JSupplier,
  resetForm,
  setDialog,
} from "../../../../app/slices/jomla/supplierSlice";
import { HiOutlineTruck, HiOutlineIdentification } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const JSupplierForm = () => {
  const dispatch = useDispatch();

  const _JSupplier = useSelector((state) => state.jSupplier.jSupplier);
  const _SearchBody = useSelector((state) => state.jSupplier.searchBody);

  const [loading, setLoading] = useState(false);

  const isAdd = _JSupplier.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: _JSupplier.form,
  });

  const onSubmit = (data) => {
    setLoading(true);
    if (isAdd) {
      dispatch(
        JSupplier.create(
          {
            name: data.name,
            note: data.note,
          },
          _SearchBody
        )
      )
        .then((x) => setLoading(false))
        .catch((e) => setLoading(false));
    } else {
      dispatch(
        JSupplier.update(
          data.id,
          {
            name: data.name,
            note: data.note,
          },
          _SearchBody
        )
      )
        .then(() => setLoading(false))
        .catch((e) => setLoading(false));
    }
  };

  useEffect(() => {
    reset({ ..._JSupplier.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JSupplier.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_JSupplier.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineTruck />}
      title={isAdd ? "إضافة مورد" : "تعديل المورد"}
      subtitle={
        isAdd
          ? "أدخل معلومات المورد لإضافته الى القائمة"
          : "قم بتحديث معلومات المورد ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_JSupplier.loading}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="معلومات المورد">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="ملاحظات"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default JSupplierForm;
